import { DealerRoutes } from "../Routes";
import {
  ThemeProvider,
  lightTheme,
} from "@poseidon/ui/styles/theme";
import { SnackbarProvider } from "notistack";
import { CrumbProvider } from "@poseidon/ui/app/crumbs/CrumbContext";
import { CssBaseline } from "@mui/material";

function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <SnackbarProvider>
        <CrumbProvider>
          <DealerRoutes />
        </CrumbProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
